import * as Category from '../groupTags/Category';
import createObjectValuesPropType from './createObjectValuesPropType';
export default createObjectValuesPropType(Category);